import { render, staticRenderFns } from "./SchoolCenteredApp.vue?vue&type=template&id=2ba25de5"
import script from "./SchoolCenteredApp.vue?vue&type=script&lang=js"
export * from "./SchoolCenteredApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports